import { ConfigSection } from "../../../components-fabric";
import { buildingParametersSection } from "./building-parameters.screens";
import { materialsSection } from "./materials.screens";
import { spaceFunctionsSection } from "./space-functions.screens";
import { structuralLayerFunctionsIndexScreen } from "./structural-layer-functions.screens";

export const buildingDataSection: ConfigSection =
  {
    id: "data",
    screens:[
      structuralLayerFunctionsIndexScreen
    ],
    sections: [
      materialsSection,
      buildingParametersSection,
      spaceFunctionsSection
    ]
  }
;
